import { createFileRoute } from '@tanstack/react-router';
import { settingsSearchSchema } from 'src/modules/settings/schemas/settings.schema';
import { CredentialsSettingsPage } from 'src/modules/settings/components/pages/credentials-settings.page';

export const Route = createFileRoute('/settings/credentials')({
  component: CredentialsSettingsPage,
  validateSearch: (search) => settingsSearchSchema.parse(search),
});
